module.exports = __webpack_public_path__ + "img/Unidad12-5.d82e760e.png";